const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	ToggleControl,
	PanelBody,
	Disabled
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/address", {
	title: __("Adresse", "wp-apidae"), // Block title.
	description: __("Affiche un bloc adresse.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.text
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		nomDuLieu: {
			type: "boolean",
			default: true,
		},
		adresse1: {
			type: "boolean",
			default: true,
		},
		adresse2: {
			type: "boolean",
			default: true,
		},
		adresse3: {
			type: "boolean",
			default: true,
		},
		commune: {
			type: "boolean",
			default: true,
		},
		codePostal: {
			type: "boolean",
			default: true,
		},
		etat: {
			type: "boolean",
			default: true,
		},
		align: {
			type: 'string',
			default: '',
		},
	},
	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;

			return [
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("Affichage")}>
							<ToggleControl
								label={ __( 'Nom du lieu' ) }
								checked={ attributes.nomDuLieu }
								onChange={ () => {
									props.setAttributes({ nomDuLieu: ! attributes.nomDuLieu });
								} }
							/>
							<ToggleControl
								label={ __( 'Adresse 1' ) }
								checked={ attributes.adresse1 }
								onChange={ () => {
									props.setAttributes({ adresse1: ! attributes.adresse1 });
								} }
							/>
							<ToggleControl
								label={ __( 'Adresse 2' ) }
								checked={ attributes.adresse2 }
								onChange={ () => {
									props.setAttributes({ adresse2: ! attributes.adresse2 });
								} }
							/>
							<ToggleControl
								label={ __( 'Adresse 3' ) }
								checked={ attributes.adresse3 }
								onChange={ () => {
									props.setAttributes({ adresse3: ! attributes.adresse3 });
								} }
							/>
							<ToggleControl
								label={ __( 'Code Postal' ) }
								checked={ attributes.codePostal }
								onChange={ () => {
									props.setAttributes({ codePostal: ! attributes.codePostal });
								} }
							/>
							<ToggleControl
								label={ __( 'Commune' ) }
								checked={ attributes.commune }
								onChange={ () => {
									props.setAttributes({ commune: ! attributes.commune });
								} }
							/>
							<ToggleControl
								label={ __( 'Etat' ) }
								checked={ attributes.etat }
								onChange={ () => {
									props.setAttributes({ etat: ! attributes.etat });
								} }
							/>
						</PanelBody>
					</InspectorControls>
				,
						<Disabled>
						<ServerSideRender
							block="wp-apidae/address"
							attributes={attributes}
							urlQueryArgs={{
							settings:template
						}}/>
					</Disabled>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
